import React from 'react';
import PropTypes from 'prop-types';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function NewButton({
  content, onClick, disabled, title,
}) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faFile}
      title={title}
      variant="falcon-info"
    />
  );
}

NewButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

NewButton.defaultProps = {
  onClick: () => null,
  content: 'Створити',
  disabled: false,
  title: 'Створити',
};

export default NewButton;
